// @flow
import React from 'react';
import { Modal } from 'antd';
import { SpH5, SpButton } from 'components/DesignKit';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
  selectedAcquirer: Object,
};

const DeleteCatalog = (props: Props) => {
  const {
    visible,
    close,
    submit,
    selectedAcquirer,
  } = props;

  const deleteAcquirer = () => {
    submit(selectedAcquirer.gid);
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={deleteAcquirer} type="danger">Delete</SpButton>,
      ]}
      title="Confirmation"
    >
      <div className="px-4">
        <div className="mt-1 mb-2">Are you sure you want to delete?</div>
        <SpH5 className="pb-3">
          <div>{selectedAcquirer.name}</div>
        </SpH5>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default DeleteCatalog;
